import { combineReducers } from 'redux';
import createLogger from 'redux-logger';
import { hospitalBookingReducer } from 'ng2/hospital-booking/store/hospital-booking.reducer';
import { kioskReducer } from 'ng2/kiosk/kiosk.reducer';
import { reasonsReducer } from 'ng2/main/reasons/reasons.reducer';
import { reasonFormReducer } from 'ng2/main/reasons/reason-form/reason-form.reducer';

import currentPatient from '../reducers/current-patient-reducer';
import group from '../reducers/group-reducer';
import notifications from '../reducers/notifications-reducer';
import offering from '../reducers/offering-reducer';
import patients from '../reducers/patients-reducer';

import session from '../reducers/session-reducer';

// IMPORTANT: THIS FILE IS DEPRECATED AND SHOULD ONLY BE USED WHEN YOU UPDATE AN OLD MODULE FROM THE ANGULAR1 NG-REDUX STORE
// Otherwise, use ngrx/store and update the store config in app/ng2/app.module.ts

const logger = createLogger({
  level: 'info',
  collapsed: true,
});

const middlewares = application.use.debug ? [logger] : [];

module.exports = ['$ngReduxProvider', ($ngReduxProvider) => {
  $ngReduxProvider.createStoreWith(combineReducers({
    currentPatient,
    group,
    notifications,
    hospitalBooking: hospitalBookingReducer,
    kiosk: kioskReducer,
    offering,
    patients,
    session,
    reasonForm: reasonFormReducer,
    reasons: reasonsReducer,
  }), middlewares);
}];



// WEBPACK FOOTER //
// ./main/config/states.js